import { BaseService } from '../../../../../core/services/base.service';
import {
  CandidateMergePreview,
  CandidateMergeResult,
  CandidateMergeSelections,
} from '../models/candidate-merge.model';

export class CandidateMergeService {
  static preview(
    firstCandidateId: string,
    secondCandidateId: string
  ): Promise<CandidateMergePreview> {
    return BaseService.Get(
      `/candidates/${firstCandidateId}/merge-preview/${secondCandidateId}`
    );
  }

  static merge(
    primaryCandidateId: string,
    sourceCandidateId: string,
    fieldSelections: CandidateMergeSelections
  ): Promise<CandidateMergeResult> {
    return BaseService.Post(`/candidates/${primaryCandidateId}/merge`, {
      sourceCandidateId,
      fieldSelections,
    });
  }
}
